import cn from '@config/tailwind/cn'

interface ComingSoonReceivedCollectionPageProps {
  className?: string
}

export function ComingSoonReceivedCollectionPage({ className }: ComingSoonReceivedCollectionPageProps) {
  return (
    <div
      className={cn(
        'srd:text-neutrals-white srd:flex srd:min-h-[80dvh] srd:w-full srd:flex-col srd:items-center srd:justify-center srd:gap-y-4 srd:text-center',
        className,
      )}
    >
      <p className='srd:bg-complementary-purple-20 srd:text-complementary-purple-100 srd:rounded-md srd:px-4 srd:py-2 srd:text-xs srd:font-semibold'>
        Segera hadir
      </p>

      <h1 className='srd:text-2xl srd:font-bold'>Terima kiriman buku dan koleksi bacaan</h1>

      <p className='srd:text-sm'>Dapatkan buku maupun koleksi bacaan dari sesama pengguna.</p>
    </div>
  )
}
